// Public fetchers for admin-managed homepage content.
// All three tables (hero_slides, featured_products, blog_posts) are RLS-gated
// to read only active/published rows for unauthenticated visitors, so these
// helpers don't need to filter again. They degrade to empty arrays when the
// migration hasn't been applied yet — script.js then falls back to its
// hardcoded defaults.

import { supabase } from './supabase.js';

export async function fetchHeroSlides() {
  const { data, error } = await supabase
    .from('hero_slides')
    .select('*')
    .eq('active', true)
    .order('sort_order', { ascending: true });
  if (error) return { data: [], error };
  return { data: data || [], error: null };
}

export async function fetchFeaturedProductIds() {
  const { data, error } = await supabase
    .from('featured_products')
    .select('product_id, sort_order')
    .order('sort_order', { ascending: true });
  if (error) return { data: [], error };
  return { data: (data || []).map(r => r.product_id), error: null };
}

export async function fetchBlogPosts() {
  const { data, error } = await supabase
    .from('blog_posts')
    .select('*')
    .eq('active', true)
    .not('published_at', 'is', null)
    .order('published_at', { ascending: false });
  if (error) return { data: [], error };
  return { data: data || [], error: null };
}
